export const removeWhiteBackgroundSx = {
  mixBlendMode: 'multiply',
  filter: 'contrast(1)',
};
